var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartSolid = function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.606c-.188 0-.376-.04-.551-.12C5.279 17.686.444 11.7.444 6.858.444 3.233 3.397.283 7.027.283c1.892 0 3.559.796 4.973 2.37 1.415-1.574 3.081-2.37 4.973-2.37 3.63 0 6.583 2.95 6.583 6.575 0 4.842-4.834 10.828-11.005 13.629-.175.079-.363.119-.551.119"
  })));
};
export default SvgHeartSolid;